import { BookFeature } from '../models/book-feature';
import { Audio } from '../models/audio';
import { Link } from '../models/link';
import { Video } from '../models/video';

/**
 * This helper is used to get the FontAweseome Icon based on the internal BookFeature data.
 */
export class IconHelper {

    static getIconToShow(bookFeature: BookFeature): string {

        if (bookFeature instanceof Audio) {
            return 'fa-play';
        }

        if (bookFeature instanceof Link) {
            return IconHelper.getLinkIcon(bookFeature);
        }

        if (bookFeature instanceof Video) {
            return IconHelper.getVideoIcon(bookFeature);
        }

        return 'fa-link';
    }

    private static getVideoIcon(bookFeature: BookFeature): string {

        const clone = bookFeature as any;
        if (clone.url && clone.url.includes('youtube')) {
            return 'fa-youtube-play';
        }
        if (clone.url && clone.url.includes('vimeo')) {
            return 'fa-vimeo-square';
        }

        return 'fa-video-camera';
    }

    private static getLinkIcon(bookFeature: BookFeature): string {

        const clone = bookFeature as any;
        if (clone.url && clone.url.includes('wikipedia')) {
            return 'fa-wikipedia-w';
        }
        if (clone.url && clone.url.includes('google')) {
            return 'fa-google';
        }
        if (clone.type === 3) {
            if (clone.url && clone.url.includes('youtube')) {
                return 'fa-youtube-play';
            }
            if (clone.url && clone.url.includes('vimeo')) {
                return 'fa-vimeo-square';
            }

            return 'fa-video-camera';
        }

        return 'fa-link';
    }

}
